import { useContext, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { AuthContext } from 'context/AuthContext';

import { getSearchParam } from 'helpers/url';
import { useNextNavigate } from 'hooks/useNextNavigate';

import { CardPageShell } from 'components/CardPageShell';

const VIEWS_WITH_TERMS = ['/login', '/reset-password', '/activate-account-credentials'];

export default function UserLayout() {
  const { user, isInitialLoad, isLoading } = useContext(AuthContext);

  const location = useLocation();
  const navigate = useNextNavigate();

  const redirectUri = getSearchParam('next');

  useEffect(() => {
    if (isInitialLoad || isLoading || !user) return;
    // take user back to previous page on login success
    // if no prev page then take user back to root
    if (redirectUri) {
      navigate(redirectUri);
    } else {
      navigate('/');
    }
  }, [user, isLoading, isInitialLoad]);

  const shouldShowTerms = VIEWS_WITH_TERMS.includes(location.pathname);

  return (
    <>
      <Helmet title="Login" />
      <CardPageShell showTerms={shouldShowTerms}>
        <Outlet />
      </CardPageShell>
    </>
  );
}
